import React from 'react';
import { FieldInputProps, FieldMetaProps, FormikProps } from 'formik';
import { SelectValue } from 'antd/lib/select';

import CustomAutoCompleteField from 'formikFields/uiWrapping/CustomAutoCompleteField';
import useCompanySuggest from 'util/hooks/useCompanySuggest';

type Props = {
  // Пропсы от Formik
  field: FieldInputProps<any>;
  form: FormikProps<any>;
  meta: FieldMetaProps<any>;

  side: 'sender' | 'receiver',
  label: string,
  currentCoords: number[],
  setCoords: (value: number[]) => void,
  handleFocusField: () => void,
  setNeedChangeFocus: (value: 'sender' | 'receiver' | null) => void;
  SetIsHandWrittenSelected: (value: boolean) => void;
};

const CompanyAutoCompleteField = ({
  field,
  form,
  meta,
  side,
  label,
  handleFocusField,
}: Props) => {
  const {
    handleSearch,
    getResultData,
    suggestions,
  } = useCompanySuggest();

  const handleSelect = (value: SelectValue) => {
    form.setFieldValue(side, {
      ...form.values[side],
      ...getResultData(`${value}`),
    });
  };

  const handleChange = (value: SelectValue) => {
    form.setFieldValue(side, {
      ...form.values[side],
      inn: undefined,
      ogrn: undefined,
      kpp: undefined,
      legalAddress: undefined,
      title: undefined,
      opfShort: undefined,
      opfFull: undefined,
      titleShort: undefined,
      titleFull: undefined,
      counterpartyId: undefined,
      companyName: value,
    });
  };

  const fieldErrors = React.useMemo(
    () => {
      const errorsSide = form.errors[side];
      // @ts-ignore
      if (!!errorsSide && errorsSide.companyName) {
        // @ts-ignore
        return errorsSide.companyName;
      }
      return null;
    },
    [form.errors],
  );

  return (
    <CustomAutoCompleteField
      field={field}
      form={form}
      meta={meta}
      options={suggestions.map((suggest) => ({
        value: suggest.value,
        text: suggest.label,
        component: (
          <div>
            <div>{ suggest.label }</div>
            <div>{ suggest.inn }</div>
          </div>
        ),
      }))}
      onSearch={handleSearch}
      onSelect={handleSelect}
      onChange={handleChange}
      onFocus={handleFocusField}
      fieldErrors={fieldErrors}
      label={label}
    />
  );
};

export default CompanyAutoCompleteField;
